import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/config/vant.js'
import 'lib-flexible/flexible'
import filter from './utils/filter'

//全局导入过滤器
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]))

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
